import BirdImage from './BirdImage';

export default BirdImage;
